import { render } from "./PageCopy.vue?vue&type=template&id=1830c6fc"
import script from "./PageCopy.vue?vue&type=script&lang=js"
export * from "./PageCopy.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/blackhall/V3/v2026.13.r1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__